import { constantRouterMap, asyncRouterMap } from '@/router'
import store from '../index'

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param {Object} route 某个路由
 * @param {Array<String>} userRoles 用户角色
 */
function hasPermission(route, userRoles) {
  const { vipExclude, vipInclude, roles } = route.meta || {}

  // 是否有权限，默认是有
  let result = true

  if (roles) {
    result = userRoles.some((role) => roles.includes(role))
  }

  // 校验cms黑名单的权限
  if (result && vipExclude) {
    const vip = store.state.user.info.vip - 0
    result = vipExclude.includes(vip) === false
  }

  // 校验cms白名单的权限
  if (result && vipInclude) {
    const vip = store.state.user.info.vip - 0
    result = vipInclude.includes(vip)
  }


  return result

  // if (route.meta && route.meta.roles) {
  //   return userRoles.some(role => route.meta.roles.includes(role))
  // }
  // else {
  //   return true // 没有mate.roles则默认全部用户都可以进入
  // }
}


/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param {Array} routes 需要筛选的路由表
 * @param {Array<String>} roles 用户角色
 */
function filterAsyncRouter(routes, roles) {
  const res = []
  routes.forEach((route) => {
    const tmpRoute = { ...route }  // 浅拷贝对象
    if (hasPermission(tmpRoute, roles)) {
      // 有子路由就递归匹配权限
      if (tmpRoute.children) {
        tmpRoute.children = filterAsyncRouter(tmpRoute.children, roles)
      }
      res.push(tmpRoute)
    }
  })
  return res
}

export default {
  state: {
    routers: constantRouterMap, // 所有路由
    addRouters: [], // 动态添加的路由(对应权限的路由？)
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
  },

  actions: {
    // 根据权限生成路由表
    async GenerateRoutes({ commit }, data) {
      const { roles } = data
      let accessRouters
      // if (roles.includes('admin')) {
      //   accessRouters = asyncRouterMap
      // }
      // else {
      //   accessRouters = await filterAsyncRouter(asyncRouterMap, roles)
      // }
      accessRouters = await filterAsyncRouter(asyncRouterMap, roles)
      commit('SET_ROUTERS', accessRouters)
    },
  },
}